import { render, staticRenderFns } from "./IrrSummaryComponent.vue?vue&type=template&id=7f4d70ca"
import script from "./IrrSummaryComponent.vue?vue&type=script&lang=js"
export * from "./IrrSummaryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports